import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import PackageDetailsContainer from '../../../components/componentsVisibility/PackageDetails/PackageDetailsContainer';

class visibilityPackageDetailsView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <PackageDetailsContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection} />
            </AnimatedView>

        );
    }
}

export default visibilityPackageDetailsView;
